import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  en: {
    greeting: 'Hello',
    welcome: 'Welcome to our site',
    home: 'HOME',
    product: 'PRODUCT',
    contact: 'CONTACT',
    login: 'LOGIN',
    register: 'REGISTER',
    sliderbigtext: 'Freight and transport orders',
    shippingservices: 'Shipping services',
    orderservice: 'Order service',
    supplyservice: 'Supply service',
    deliveryservice: 'Delivery service',
    productresearch: 'Product research',
    how: 'How',
    can: 'can',
    wehelpyou: 'we help you?',
    addtocard: 'Add to card',
    username: 'Username',
    password: 'Password',
    phone: 'Phone',
    repassword: 'Re password',
    enteryourlastname: 'Enter your lastname',
    successorder: 'SUCCESS',
    company: 'COMPANY',
    forgetpassword: 'Forget password'
  },
  mn: {
    greeting: 'Сайна уу ',
    welcome: 'Тавтай морилно уу',
    home: 'НҮҮР',
    product: 'БҮТЭЭГДЭХҮҮН',
    contact: 'ХОЛБОО БАРИХ',
    login: 'НЭВТРЭХ',
    register: 'Тэмцээнд бүртгүүлэх',
    sliderbigtext: 'Ачаа тээвэр захиалга',
    shippingservices: 'Тээвэрлэлтийн үйлчилгээ',
    orderservice: 'Захиалгын үйлчилгээ',
    supplyservice: 'Нийлүүлэлтийн үйлчилгээ',
    deliveryservice: 'Хүргэлтийн үйлчилгээ',
    productresearch: 'Бараа бүтээгдэхүүн судалгаа',
    how: 'Бид',
    can: 'танд',
    wehelpyou: 'юугаар туслах вэ?',
    addtocard: 'Сагсанд хийх',
    username: 'Нэвтрэх нэр',
    password: 'Нууц үг',
    phone: 'Утас',
    repassword: 'Нууц үг /ахин/',
    enteryourlastname: 'Та нэрээ оруулна уу',
    successorder: 'Амжилттай',
    company: 'БАЙГУУЛЛАГА',
    forgetpassword: 'Нууц үг сэргээх'
  }
}

const i18n = new VueI18n({
  locale: 'mn', // Set default language
  fallbackLocale: 'mn',
  messages
})

export default i18n
